import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

const SectionTitle = props => {
    return (
        <div className={styles.root}>
            <div className={styles.title}>
                {props.title}
                {props.action && <span className={styles.action}>{props.action}</span>}
            </div>
            {props.subtitle && <div className={styles.subtitle}>{props.subtitle}</div>}
        </div>
    );
};

SectionTitle.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    action: PropTypes.node,
};

export default SectionTitle;



// WEBPACK FOOTER //
// ./components/section-title/index.js